import FeeTypeTable from "./FeeTypeTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const FeeType = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_configureagreement_policytype_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>{userPermissions.includes(viewPermission) && <FeeTypeTable />}</>
  );
};

export default FeeType;
